import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './layout/header/header.component';
import { AuthService } from '../app/core/services/auth.service';
import { CompanyCodeService } from './core/services/company-code.service';
import { BannerContainerComponent } from './shared/components/banner-container/banner-container.component';
import { FaqDocumentService } from './core/services/faq-document.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, BannerContainerComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'billing-request';
  
  constructor(
    private authService: AuthService,
    private companyCodeService: CompanyCodeService,
    private faqDocumentService: FaqDocumentService
  ) {}
  
  async ngOnInit(): Promise<void> {
    // Handle redirect callback and initiate auth flow
    // This runs after MSAL is initialized (via APP_INITIALIZER)
    await this.authService.initOnStart();

    // Non-blocking background preload for FAQ document cache
    this.faqDocumentService.preloadInBackground();
    
    // Load regions once when app starts
    this.companyCodeService.loadRegions().subscribe({
      error: (err) => console.error('Failed to load regions:', err)
    });
  }
}
